import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { CheckLimitRequest, CheckLimitResponse, PaymentsApi } from '@shared/api/rest/payments';
import { useNotificationStore } from '../misc';
import { Constants } from '@shared/widgets';

export interface StoreBaseReturn<T> {
  loading: boolean;
  data: T;
  error?: string | null;
}

interface UseCheckLimitStore {
  loading: boolean;
  data: CheckLimitResponse | null;
  error?: string | null;
  checkLimit: (request: CheckLimitRequest) => Promise<StoreBaseReturn<CheckLimitResponse | null>>;
  clear: () => void;
}

export const useCheckLimitStore = create<UseCheckLimitStore>((set) => ({
  loading: false,
  data: null,
  error: null,

  checkLimit: async (request) => {
    try {
      set({ loading: true, data: null, error: null });
      const response = await PaymentsApi.checkLimit(request);
      set({ data: response.data, loading: false });
      return { loading: false, data: response.data };
    } catch (error) {
      const restError = ApiUtils.getApiError(error);
      set({ loading: false, data: null, error: restError });
      useNotificationStore.getState().setError(Constants.DEFAULT_ERROR_MESSAGE);
      return { loading: false, data: null, error: restError };
    }
  },

  clear: () => set({ data: undefined, loading: false, error: null }),
}));
